import React from "react";
import PropTypes from "prop-types";
import { marked } from "marked";
import DOMPurify from "dompurify";

/**
 * Content block component with image and text in flexible left/right layout
 * Supports markdown text parsing and sanitizes HTML output
 *
 * @component
 * @param {Object} props
 * @param {string} props.title - Content title
 * @param {string} props.text - Markdown text content
 * @param {string} props.image - Image URL
 * @param {string} [props.image_position="right"] - Image position: "left" or "right"
 */
const ContentWithImage = ({ title, text, image, image_position = "right" }) => {
  const imagePosition = image_position === "left" ? "left" : "right"; // Default: Image on the right

  // Parse markdown text and sanitize HTML
  const parseMarkdownText = (markdownText) => {
    if (!markdownText) return "";

    // Convert markdown to HTML
    const rawHTML = marked.parse(markdownText);

    // Sanitize HTML to prevent XSS attacks
    const cleanHTML = DOMPurify.sanitize(rawHTML);

    return cleanHTML;
  };

  return (
    <div className={`ContentWithImage ${imagePosition}`}>
      <div className="image">
        <img src={image} alt={title} />
      </div>

      <div className="text">
        <h2>{title}</h2>
        <div className="content-rich-text" dangerouslySetInnerHTML={{ __html: parseMarkdownText(text) }} />
      </div>
    </div>
  );
};

ContentWithImage.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired, // Markdown text as string
  image: PropTypes.string.isRequired, // URL?
  image_position: PropTypes.oneOf(["left", "right"]),
};
export default ContentWithImage;
